import { useCallback, useRef, useState } from 'react'

import {
    AsyncAction,
    createSingleFlightRunner,
} from '../utils/singleFlight'

export const useSingleFlightAction = <Args extends unknown[], Result>(
    action: AsyncAction<Args, Result>
) => {
    const runningRef = useRef(false)
    const activePromiseRef = useRef<Promise<Result> | null>(null)
    const [running, setRunning] = useState(false)

    const run = useCallback(
        (...args: Args): Promise<Result> => {
            if (!activePromiseRef.current) {
                activePromiseRef.current = createSingleFlightRunner(
                    action,
                    (nextRunning) => {
                        runningRef.current = nextRunning
                        setRunning(nextRunning)
                    }
                )(...args).finally(() => {
                    activePromiseRef.current = null
                })
            }

            return activePromiseRef.current
        },
        [action]
    )

    return { run, running }
}
